import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { debounce } from 'throttle-debounce';
import { calculateTextSpaces } from '../utils/calculateTextSpaces';
import styles from './AllSpaceText.css';
import { jsx as _jsx } from "react/jsx-runtime";
const MIN_FONT_SIZE = 8;
export const AllSpaceText = _ref => {
  let {
    text,
    height,
    heightPercent,
    minFontSize = MIN_FONT_SIZE,
    onAllSpaceCalculated
  } = _ref;
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [letterSpacing, setLetterSpacing] = useState(0); // начальное расстояние между буквами
  const [wordSpacing, setWordSpacing] = useState(0); // начальное расстояние между словами

  const adjustText = useCallback((containerEl, textEl) => {
    const textSpaces = calculateTextSpaces(containerEl, textEl);
    setLetterSpacing(textSpaces.letterSpacing);
    setWordSpacing(textSpaces.wordSpacing);
    return textSpaces;
  }, []);
  const adjustTextDebounced = useMemo(() => debounce(500, adjustText), [adjustText]);
  useEffect(() => {
    if (!containerRef.current || !textRef.current) {
      return;
    }
    const containerEl = containerRef.current;
    const textEl = textRef.current;
    const textSpaces = adjustText(containerEl, textEl);

    // Если функция вернула true, то не нужно делать лишние действия
    if (onAllSpaceCalculated !== null && onAllSpaceCalculated !== void 0 && onAllSpaceCalculated(textSpaces)) {
      return;
    }
    const observer = new ResizeObserver(() => adjustTextDebounced(containerEl, textEl));
    observer.observe(containerEl);
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);
  return /*#__PURE__*/_jsx("div", {
    className: styles['container'],
    ref: containerRef,
    children: /*#__PURE__*/_jsx("span", {
      className: styles['text'],
      ref: textRef,
      style: {
        fontSize: Math.max(minFontSize, height * (heightPercent / 100)),
        letterSpacing,
        wordSpacing
      },
      children: text
    })
  });
};